module.exports = __webpack_public_path__ + "img/07.bcd02c1e.webp";